
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18 0C8.075 0 0 8.075 0 18s8.075 18 18 18 18-8.075 18-18S27.925 0 18 0zm0 33.75C9.317 33.75 2.25 26.685 2.25 18 2.25 9.315 9.317 2.25 18 2.25S33.75 9.315 33.75 18c0 8.685-7.067 15.75-15.75 15.75z","fill":"#0183FE"}}),_c('path',{attrs:{"d":"M30.798 20.695a1.12 1.12 0 00-.895-.445H6.098a1.128 1.128 0 00-1.082 1.431C6.641 27.461 11.98 31.5 18 31.5s11.358-4.039 12.985-9.819c.094-.34.027-.704-.187-.986zM18 29.25c-4.502 0-8.548-2.711-10.31-6.75h20.62c-1.762 4.039-5.808 6.75-10.31 6.75zM26.548 15.975L23.249 13.5l3.301-2.475a1.125 1.125 0 10-1.348-1.8l-4.5 3.375a1.124 1.124 0 00-.002 1.8l4.5 3.375a1.124 1.124 0 101.348-1.8zM15.3 12.6l-4.5-3.375a1.13 1.13 0 00-1.575.225 1.126 1.126 0 00.225 1.575l3.3 2.475-3.3 2.475A1.126 1.126 0 0010.125 18c.234 0 .472-.074.675-.225l4.5-3.375a1.124 1.124 0 000-1.8z","fill":"#0183FE"}})])
          )
        }
      }
    